module.exports = {"data":{"TopParagraph":{"html":"<h1>Contact</h1>\n<p>If you want to learn more about our solutions for candidates, political parties and elected politicians then don't hesitate to get in touch using any of the methods below:</p>","frontmatter":{"name":"Contact"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 366
// module chunks = 184662623972074